/**
 * Parses a time string into milliseconds.
 * @param input
 */
export function parseToMilliseconds(input: string): number | null {
    const units: Record<string, number> = {
        ms: 1,
        s: 1000,
        m: 60_000,
        h: 3_600_000,
    }

    const match = input.trim().match(/^(\d+(?:\.\d+)?)\s*(ms|s|m|h)$/i)
    if (!match) return null

    const value = parseFloat(match[1]!)
    const unit = match[2]?.toLowerCase() ?? ''

    const multiplier = units[unit]
    if (multiplier === undefined) return null
    return value * multiplier
}
